import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useState } from 'react';
import FeatherIcon from "../../ui/feather-icon/FeatherIcon";
import PropTypes from "prop-types";
import ContextMenu from "../../ui/context-menu/ContextMenu";
import ContextMenuItem from "../../ui/context-menu/ContextMenuItem";
import { RandomStringGenerator } from "noood/util/rand/RandomStringGenerator";
import Spacer from "../../ui/spacer/Spacer";
import FlexJustified from "noood/comp/ui/containers/flex-boxes/FlexJustified";
import BlockDiv from "noood/comp/ui/containers/BlockDiv";
import Text from "noood/comp/text/Text";
import Icon from "noood/comp/ui/feather-icon/Icon";
import * as stylex from '@stylexjs/stylex';
import { SearchFilterFormContext } from "noood/contexts/contexts";
import { string_util } from "noood/util/string/StringUtil";
import { styling } from "noood/styles/styles.stylex";
export default function SearchFilterTextfield(props) {
  var id = RandomStringGenerator.alphanum(10);
  var _useState = useState('xx'),
    _useState2 = _slicedToArray(_useState, 2),
    match_type = _useState2[0],
    set_match_type = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    context = _useState4[0],
    set_context = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    val = _useState6[0],
    set_val = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    outside = _useState8[0],
    set_outside = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    isFocused = _useState0[0],
    setIsFocused = _useState0[1];

  /**
   * @type {SearchFilterFormContextMethods} formCtx
   */
  var formCtx = useContext(SearchFilterFormContext);
  var __context = function __context(show, e) {
    return /*#__PURE__*/React.createElement(ContextMenu, {
      sender: e.target,
      id: id,
      _wasClosed: function _wasClosed() {
        set_context(undefined);
      },
      show: show,
      __collect: function __collect(context_value) {
        set_match_type(context_value);
        set_context(null);
        formCtx.__collect({
          property: props.name,
          match_mode: context_value,
          value: val
        });
      }
    }, /*#__PURE__*/React.createElement(ContextMenuItem, {
      selected: match_type === '==',
      icon: "check",
      value: '==',
      label: 'Exact Match'
    }), /*#__PURE__*/React.createElement(ContextMenuItem, {
      selected: match_type === '-x',
      icon: "arrow-left",
      value: '-x',
      label: 'Starts with'
    }), /*#__PURE__*/React.createElement(ContextMenuItem, {
      selected: match_type === 'x-',
      icon: "arrow-right",
      value: 'x-',
      label: 'Ends with'
    }), /*#__PURE__*/React.createElement(ContextMenuItem, {
      selected: match_type === 'xx',
      icon: "minimize-2",
      value: 'xx',
      label: 'Contains'
    }), /*#__PURE__*/React.createElement(ContextMenuItem, {
      selected: match_type === '!o',
      icon: "minimize-2",
      value: '!o',
      label: 'Not Empty'
    }), /*#__PURE__*/React.createElement(ContextMenuItem, {
      selected: match_type === 'oo',
      icon: "circle",
      value: 'oo',
      label: 'Empty',
      isLast: true
    }));
  };
  var __get_match_description = function __get_match_description(type) {
    var type_description = '';
    switch (type) {
      case '==':
        type_description = 'Exact Match';
        break;
      case '-x':
        type_description = 'Starts with';
        break;
      case 'x-':
        type_description = 'Ends with';
        break;
      case 'xx':
        type_description = 'Contains';
        break;
      case '!o':
        type_description = 'Not Empty';
        break;
      case 'oo':
        type_description = 'Empty';
        break;
    }
    return /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: 'uppercase',
        fontSize: '10px',
        color: "var(--shade-20)",
        borderRadius: '3px',
        padding: '1px 3px'
      }
    }, type_description);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FlexJustified, null, props.label ? /*#__PURE__*/React.createElement(BlockDiv, null, /*#__PURE__*/React.createElement("span", {
    className: "SearchFilterTextfield__ui.label evfifm61"
  }, props.label)) : !props.placeholder && /*#__PURE__*/React.createElement(BlockDiv, null, /*#__PURE__*/React.createElement(Text, {
    size: 13
  }, string_util.uc_words(props.name, "_"))), props.showMatchMode && /*#__PURE__*/React.createElement("nobr", null, __get_match_description(match_type))), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 2
  }), /*#__PURE__*/React.createElement("div", stylex.props(ui.the_field, isFocused && styling.focusRing), props.icon && /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    color: "var(--shade-60)"
  }), /*#__PURE__*/React.createElement("input", _extends({
    value: val,
    type: "text",
    placeholder: props.placeholder
  }, {
    className: "SearchFilterTextfield__ui.input_field ev1wty727 ev1a2a7pz ev98rzlu ev1md70p1 ev193iq5w evh8yej3 ev4z9k3i ev1717udv ev1ghz6dp ev5ea3kt"
  }, {
    onKeyDown: function onKeyDown(e) {
      if (e.code === "Enter") {
        var _formCtx$__virtualSub;
        (_formCtx$__virtualSub = formCtx.__virtualSubmit) === null || _formCtx$__virtualSub === void 0 || _formCtx$__virtualSub.call(formCtx);
      }
    },
    onFocus: function onFocus(e) {
      return setIsFocused(true);
    },
    onBlur: function onBlur(e) {
      return setIsFocused(false);
    },
    onChange: function onChange(e) {
      var _formCtx$__collect, _e$target$value;
      set_val(e.target.value);
      (_formCtx$__collect = formCtx.__collect) === null || _formCtx$__collect === void 0 || _formCtx$__collect.call(formCtx, {
        property: props.name,
        value: (_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.trim(),
        match_mode: match_type
      });
    }
  })), props.showMatchMode && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      if (!context) {
        set_context(__context(true, e));
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: context ? 'chevron-up' : 'chevron-down',
    color: "var(--shade-50)"
  }), context), /*#__PURE__*/React.createElement("table", {
    className: "flex collapsed",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, props.icon && /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '3px 5px'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      verticalAlign: 'initial'
    }
  }, /*#__PURE__*/React.createElement("input", {
    value: val,
    type: "text",
    placeholder: props.placeholder,
    onChange: function onChange(e) {
      var _formCtx$__collect2, _e$target$value2;
      set_val(e.target.value);
      (_formCtx$__collect2 = formCtx.__collect) === null || _formCtx$__collect2 === void 0 || _formCtx$__collect2.call(formCtx, {
        property: props.name,
        value: (_e$target$value2 = e.target.value) === null || _e$target$value2 === void 0 ? void 0 : _e$target$value2.trim(),
        match_mode: match_type
      });
    }
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      paddingRight: '5px',
      backgroundColor: '#ccc'
    }
  }, /*#__PURE__*/React.createElement(FeatherIcon, {
    onClick: function onClick(e) {
      set_context(context ? null : __context(true, e));
    },
    icon: context ? 'chevron-up' : 'chevron-down'
  }), context))))), props.spacer && /*#__PURE__*/React.createElement(Spacer, {
    mtop: props.spacer
  }));
}
SearchFilterTextfield.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  spacer: PropTypes.number,
  showMatchMode: PropTypes.bool,
  placeholder: PropTypes.string,
  formContext: PropTypes.object
};
SearchFilterTextfield.defaultProps = {
  showMatchMode: true
};
_inject(".ev1bkuceq{border:1px solid var(--shade-20)}", 1000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev5t5jma{padding:4px 7px}", 1000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev1jnr06f{gap:4px}", 2000);
_inject(".ev1fgtraw{height:28px}", 4000);
_inject(".evfifm61{font-size:12px}", 3000);
_inject(".ev1wty727{border:0}", 1000);
_inject(".ev1a2a7pz{outline:none}", 2000);
_inject(".ev98rzlu{flex:1}", 2000);
_inject(".ev1md70p1{background:transparent}", 1000);
_inject(".ev193iq5w{max-width:100%}", 4000);
_inject(".evh8yej3{width:100%}", 4000);
_inject(".ev4z9k3i{font-size:13px}", 3000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".ev5ea3kt{color:var(--shade-70)}", 3000);
var ui = {
  the_field: {
    "SearchFilterTextfield__ui.the_field": "SearchFilterTextfield__ui.the_field",
    border: "ev1bkuceq",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "ev1y7ric0",
    display: "ev78zum5",
    padding: "ev5t5jma",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    alignItems: "ev6s0dn4",
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    gap: "ev1jnr06f",
    rowGap: null,
    columnGap: null,
    height: "ev1fgtraw",
    $$css: true
  }
};